
import Zen2HanMap from "./zen2han.map";

const Zen2Han = {

	options: {
		alphabet: true,
		number: true,
		space: true,
		symbol: true
	},

	config (options){
		options = $.extend(true, {}, options);
		$.extend(this.options, options);
	},

	parse (str){
		var map = Zen2HanMap.map(this.options);
		_.each(map, (value, key) => {
			var s = new RegExp(String.fromCharCode(key), "g");
			str = str.replace(s, String.fromCharCode(value));
		});
		return str;
	}

};


export default Zen2Han;



// WEBPACK FOOTER //
// ./src/js/lib/zen2han.js